module.exports = __webpack_public_path__ + "static/media/banner1.a522225d.png";